import { useState } from 'react';
import styles from './EditNote.module.css';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import UploadBox from '../../components/UploadBox/UploadBox';
import TextArea from '../../components/TextArea/TextArea';

import { FaFileAlt, FaRegStickyNote } from 'react-icons/fa';

const EditNote = () => {
  const [description, setDescription] = useState('');
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatch = useDispatch();

  const handleSave = () => {
    console.log('Description:', description);
    console.log('Uploaded file:', uploadedFile);
    // Add submission logic here
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setDescription('');
    setUploadedFile(null);
  };

  return (
    <div className={styles.cardContainer}>
      {/* Header */}
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<FaFileAlt />}
          heading="Edit Note"
          color="var(--Primary_Color)"
        />
        <ToClose onClose={handleClose} />
      </div>

      {/* Body */}
      <div className={styles.body}>
        <div className={styles.formGroup}>
          <TextArea
            label="Add description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Type your message here"
            required
          />
        </div>

        <div className={styles.formGroup}>
          <UploadBox
            onChange={(e) => setUploadedFile(e.target.files[0])}
            label="Attachment"
            innerLabel="Browse and upload files from device"
          />
        </div>

        <div className={styles.actions}>
          <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
};

export default EditNote;
